<template>
  <div class="dialog-wrap">
    <el-dialog title="内容审核"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open"
               width="700px">
      <div class="title">{{questionTitle}}</div>
      <div class="content">{{answer_content}}</div>
      <div class="imgUrl"
           v-if="this.answer_img_urls.length > 0">
        <div v-for="(item,index) in answer_img_urls"
             :key="index"
             class="itemImg"><img :src="item"
               alt=""></div>
      </div>
      <div class="pass">
        <div class="hui">精选</div>
        <el-switch v-model="activeSwitch"
                   :active-value="1"
                   :inactive-value="0"
                   @change="switchChange">
        </el-switch>

      </div>
      <div class="pass">
        <div class="hui">驳回理由</div>
        <el-input type="textarea"
                  maxlength="50"
                  placeholder="请输入内容"
                  v-model="rejection">
        </el-input>

      </div>
      <div slot="footer"
           class="dialog-footer">
        <div @click="handleRefuse"
             class="refuse">拒绝</div>
        <div type="primary"
             @click="handleSucess"
             class="sucess">通过</div>
        <div type="primary"
             @click="handleTo"
             class="sucessTo">通过并继续</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  userAnswerDetail,
  questionDetail,
  questionList,
  check,
} from '@/api/senior'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detaiRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activeSwitch: 0,
      flag: false,
      dialogVisible: false,
      detail: {},
      details: {},
      questionTitle: '',
      answer_content: '',
      rejection: '',
      passFlag: false,
      nocheckList: [],
      answer_img_urls: [],
      p: 0,
      switch: 0,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    detaiRow(val) {
      console.log('val', val)
      this.detail = val
      this.answer_img_urls =
        val.answer_img_urls != '' ? val.answer_img_urls.split(',') : []
    },
  },
  created() {},
  methods: {
    switchChange(e) {
      if (e == 0) {
        this.switch = 0
      } else if (e == 1) {
        this.switch = 1
      }
    },
    open() {
      let data = {
        id: this.detail.id,
      }
      this.detailquest(data)

      setTimeout(() => {
        this.p = this.nocheckList
          .map((item) => item.question_id)
          .indexOf(this.details.id)
        this.nocheckList.splice(this.p, 1)
        this.nocheckList.unshift(this.detaiRow)
      }, 500)
    },
    detailquest(data) {
      userAnswerDetail(data).then((res) => {
        this.answer_content = res.answer_content
        this.activeSwitch = res.picked_status
        questionDetail({ id: res.question_id }).then((res) => {
          this.details = res
          this.questionTitle = res.question_title

          this.questionLists()
        })
      })
    },

    //筛选出未审核的数据
    questionLists() {
      this.nocheckList = []
      questionList({ check_statuses: 0 }).then((res) => {
        res.list.map((item) => {
          this.nocheckList.push(item)
        })
      })
    },
    checks(data) {
      check(data).then((res) => {
        this.$emit('submit')
        this.$emit('close')
        this.nocheckList = []
      })
    },
    handleClose() {
      this.nocheckList = []
      this.$emit('close')
    },
    handleSubmit() {
      this.$emit('close')
    },
    handleRefuse() {
      this.passFlag = true
      let data = {
        id: this.nocheckList[0].id,
        check_status: 2,
        refuse_reason: this.rejection,
      }
      this.checks(data)
      this.$message.success(`审核不通过`)
      this.rejection = ''
    },
    handleSucess() {
      let data = {
        id: this.nocheckList[0].id,
        check_status: 1,
        picked_status: this.switch,
      }
      this.checks(data)
      this.$message.success(`审核通过`)
    },
    // 批量审核
    handleTo() {
      if (this.nocheckList.length == 0) {
        this.$emit('close')
        this.$message.success(`暂时待审核没有数据了`)
        this.nocheckList = []
        return
      } else {
        let datas = {
          id: this.nocheckList[0].id,
          check_status: 1,
          picked_status: this.switch,
        }
        check(datas).then((res) => {
          this.$emit('submit')
          this.$message.success(`审核通过请继续下一条`)
          this.nocheckList.splice(0, 1)
          this.detailquest({
            id: this.nocheckList[0].id,
          })
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-textarea__inner {
  width: 300px !important;
}
::v-deep .el-dialog__header {
  font-size: 18px;
  background: #ebeef5;
  border-radius: 4px 4px 0px 0px;
  padding: 10px 10px 10px !important;
}
.dialog-wrap {
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #303133;
  }
  .content {
    margin-top: 22px;
    font-weight: 400;
    font-size: 14px;
    color: #303133;
  }
  .imgUrl {
    margin-top: 10px;
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    .itemImg {
      width: 100px;
      height: 100px;
      margin-right: 12px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .pass {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .hui {
      width: 80px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    .refuse {
      cursor: pointer;
      font-size: 14px;
      width: 50px;
      height: 30px;
      color: #f56c6c;
      background: rgba(245, 108, 108, 0.2);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #f56c6c;
      text-align: center;
      line-height: 30px;
      margin-right: 5px;
    }
    .sucess {
      cursor: pointer;
      font-size: 14px;
      width: 50px;
      height: 30px;
      color: #409eff;
      background: rgba(64, 158, 255, 0.2);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #409eff;
      text-align: center;
      line-height: 30px;
      margin-right: 5px;
    }
    .sucessTo {
      cursor: pointer;
      font-size: 14px;
      width: 85px;
      height: 30px;
      color: #fff;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #409eff;
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>
